
export const CREATE_REPORT_FLOW = `
  mutation CreateReportFlow($object: report_flows_insert_input!) {
    insert_report_flows_one(object: $object) {
      id
      flow_title
      flow_description
      job_types
      source_type
      filter_config
      flow_type
      start_date
      end_date
      report_type_ids
      job_statuses
      is_active
      company_id
      created_by
      created_at
      updated_at
    }
  }
`;

export const UPDATE_REPORT_FLOW = `
  mutation UpdateReportFlow($id: Int!, $set: report_flows_set_input!) {
    update_report_flows_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      flow_title
      flow_description
      job_types
      source_type
      filter_config
      flow_type
      start_date
      end_date
      report_type_ids
      job_statuses
      is_active
      company_id
      updated_at
    }
  }
`;

export const DELETE_REPORT_FLOW = `
  mutation DeleteReportFlow($id: Int!) {
    delete_report_flows_by_pk(id: $id) {
      id
    }
  }
`;

// ─── Report Flow Columns ───────────────────────────────────────────────────────

export const CREATE_REPORT_FLOW_COLUMN = `
  mutation CreateReportFlowColumn($object: report_flow_columns_insert_input!) {
    insert_report_flow_columns_one(object: $object) {
      id
      flow_id
      column_title
      column_order
      column_color
      is_completion_column
      column_action
      created_at
      updated_at
    }
  }
`;

export const UPDATE_REPORT_FLOW_COLUMN = `
  mutation UpdateReportFlowColumn($id: Int!, $set: report_flow_columns_set_input!) {
    update_report_flow_columns_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      flow_id
      column_title
      column_order
      column_color
      is_completion_column
      column_action
      updated_at
    }
  }
`;

export const DELETE_REPORT_FLOW_COLUMN = `
  mutation DeleteReportFlowColumn($id: Int!) {
    delete_report_flow_columns_by_pk(id: $id) {
      id
    }
  }
`;

export const REORDER_FLOW_COLUMNS = `
  mutation ReorderFlowColumns($updates: [report_flow_columns_updates!]!) {
    update_report_flow_columns_many(updates: $updates) {
      affected_rows
      returning {
        id
        column_order
      }
    }
  }
`;

// ─── Report Flow Items ─────────────────────────────────────────────────────────

export const CREATE_REPORT_FLOW_ITEM = `
  mutation CreateReportFlowItem($object: report_flow_items_insert_input!) {
    insert_report_flow_items_one(object: $object) {
      id
      flow_id
      column_id
      job_id
      report_id
      item_order
      completion_date
      submission_date
      is_archived
      company_id
      created_by
      created_at
      updated_at
    }
  }
`;

export const BULK_CREATE_REPORT_FLOW_ITEMS = `
  mutation BulkCreateReportFlowItems($objects: [report_flow_items_insert_input!]!) {
    insert_report_flow_items(objects: $objects) {
      affected_rows
      returning {
        id
        flow_id
        column_id
        job_id
        report_id
      }
    }
  }
`;

export const UPDATE_REPORT_FLOW_ITEM = `
  mutation UpdateReportFlowItem($id: Int!, $set: report_flow_items_set_input!) {
    update_report_flow_items_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      flow_id
      column_id
      job_id
      report_id
      item_order
      completion_date
      submission_date
      is_archived
      updated_at
    }
  }
`;

export const MOVE_ITEM_TO_COLUMN = `
  mutation MoveItemToColumn($id: Int!, $column_id: Int!, $item_order: Int!) {
    update_report_flow_items_by_pk(
      pk_columns: { id: $id }
      _set: { column_id: $column_id, item_order: $item_order }
    ) {
      id
      flow_id
      column_id
      item_order
      updated_at
    }
  }
`;

export const DELETE_REPORT_FLOW_ITEM = `
  mutation DeleteReportFlowItem($id: Int!) {
    delete_report_flow_items_by_pk(id: $id) {
      id
    }
  }
`;

// ─── Job Reports JSONB ─────────────────────────────────────────────────────────

export const UPDATE_JOB_REPORTS = `
  mutation UpdateJobReports($jobId: uuid!, $reports: jsonb!) {
    update_jobs_by_pk(pk_columns: {id: $jobId}, _set: {job_reports: $reports}) {
      id
      job_reports
    }
  }
`;

